import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import { confirmationEmail } from "./../../reducer/actions";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import ContentWrapper from "../../../../common/components/contentWrapper";

const VerificationEmail = ({ onBackToLogin }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [hideResend, setHideResend] = useState(false);
  const [userData, setUserData] = useState(() => {
    try {
      const data = sessionStorage.getItem("registerPayload");
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  });

  const sendEmail = (data) => {
    if (!data) return;
    setLoading(true);
    const payload = {
      email: data.email,
      firstName: data.first_name,
      lastName: data.last_name
    };

    confirmationEmail(payload, (err, res) => {
    setLoading(false);
      if (err) {
        console.error("Email Error:", err);
      } else {
        // console.log("Email Sent:", res);
       if (res?.success === 1) {
        toast(res.message || "Resend Mail Send Successfully", {
            autoClose: 5000,
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.BOTTOM_CENTER,
        });
       }
      }
    });
  };

  useEffect(() => {
    if (userData?.email && userData?.first_name && userData?.last_name) {
      sendEmail(userData);
    } else {
      console.log(" Missing userData:", userData);
    }
  }, []);

  const handleResend = () => {
   setHideResend(true);
   sendEmail(userData, true); 
  };
  const contentView = (
    <Container maxWidth="sm">
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        py={4}
      >
        <Card
          elevation={3}
          sx={{
            width: '100%',
            borderRadius: 3,
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <Stack spacing={3} alignItems="center" textAlign="center">

              <Box
                sx={{
                  width: 72,
                  height: 72,
                  borderRadius: '50%',
                  bgcolor: 'primary.light',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <MarkEmailReadOutlinedIcon
                  color="primary"
                  sx={{ fontSize: 36 }}
                />
              </Box>

              <Box>
                <Typography variant="h4" fontWeight={700} gutterBottom >
                  You're almost there!
                </Typography>
                <Typography className="normal-font">
                  Thanks for signing up! To complete your registration, please confirm your email address.
                </Typography>
              </Box>

              <Box>
                <Typography  sx={{ mb: 0.5 }} className="normal-font">
                  We've sent a confirmation link to 
                </Typography>

                <Typography
                variant='h3'
                component={'h3'}
                  fontWeight={600}
                  fontSize='18px !important'
                  color='#000'
                  sx={{ wordBreak: 'break-word' }}
                >
                  {userData?.email || 'your email address'} 
                </Typography>
              </Box>

              <Box>
                <Typography className="normal-font" sx={{ mb: 1 }}>
                  Simply click the link in that email to activate your account. For security, the link will expire in 7 days.
                </Typography>

                {/* <Typography className="normal-font" sx={{ mb: 1 }}>
                  Your account will only be activated after you confirm your email address.
                </Typography> */}

                {/* <Typography className="normal-font">
                  <strong>Note:</strong> The confirmation link will expire in <strong>7 days</strong>.
                </Typography> */}
              </Box>

              <Box>
                <Typography className="normal-font">
                  Can't find the email? Be sure to check your Spam or Junk folder.
                </Typography>
              </Box>

              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                width="100%"
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  onClick={handleResend} 
                  disabled={loading} 
                  sx={{ minWidth: 160 }}
                  className="SubmitColor space-m-1"
                >
                {loading ? (
                    <CircularProgress size={20} color="inherit" />
                ) : (
                    "Resend Email"
                )}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => history.push("/login")}
                  className="SubmitColor space-m-1"
                >
                  Back to Login
                </Button>
              </Stack>

            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
return <ContentWrapper contentView={contentView} />;
};

export default VerificationEmail;